/**
 * Whether anyone has touched the running session: this client's own input, or a peer's via Ably `USER_ACTIVITY`. Module state, never Redux: input arrives per pointer move.
 */

let active = false
let running = false
let warning = false
let send = () => {}

export const wasActive = () => active

export const setActivitySender = fn => {
	send = fn
}

// Set by `useIdleGuard`: input counts only while a running session is guarded, and not while its warning is up. A session that ends forgets its input.
export const setActivityGate = (isRunning, isWarning) => {
	running = isRunning
	warning = isWarning
	if (!running) active = false
}

// The first input publishes once, so every peer's idle timer ends with it. `force` is the warning's own button: it counts even while the warning is up.
export const markActivity = ({ force = false } = {}) => {
	if (active || !running || (warning && !force)) return
	active = true
	send()
}

export const noteRemoteActivity = () => {
	active = true
}
